import { render } from "./EnquiriesREA.vue?vue&type=template&id=cb00a144&scoped=true&ts=true&lang=pug"
import script from "./EnquiriesREA.vue?vue&type=script&lang=ts&setup=true"
export * from "./EnquiriesREA.vue?vue&type=script&lang=ts&setup=true"

import "./EnquiriesREA.vue?vue&type=style&index=0&id=cb00a144&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb00a144"]])

export default __exports__